/**
 * @deprecated Use `formatBytesToBinary` or `formatBytesToDecimal` to get accurate units instead.
 */
export const formatBytes = (bytes: number | string = 0, decimals = 2): string => {
  bytes = typeof bytes === "string" ? Number(bytes) : bytes;
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + (sizes[i] || "");
};

/**
 * Converts a byte value into a human-readable string using IEC binary units (e.g., KiB, MiB).
 *
 * @param bytes - The number of bytes to format. Can be a number or a string representation of a number.
 * @param decimals - The number of decimal places to include in the formatted output. Defaults to 2.
 * @returns A formatted string representing the byte value in binary units.
 */
export const formatBytesToBinary = (bytes: number | string = 0, decimals = 2): string => {
  bytes = typeof bytes === "string" ? Number(bytes) : bytes;
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + (sizes[i] || "");
};

/**
 * Converts a byte value into a human-readable string using SI decimal units (e.g., KB, MB).
 *
 * @param bytes - The number of bytes to format. Can be a number or a string representation of a number.
 * @param decimals - The number of decimal places to include in the formatted output. Defaults to 2.
 * @returns A formatted string representing the byte value in decimal units.
 */
export const formatBytesToDecimal = (bytes: number | string = 0, decimals = 2): string => {
  bytes = typeof bytes === "string" ? Number(bytes) : bytes;
  if (bytes === 0) return "0 Bytes";

  const k = 1000;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + (sizes[i] || "");
};
